import DatasetReports from "../app/Dashboard/Datasets/DatasetReports";
import DatasetURLsWhitelist from "../app/Dashboard/Datasets/DatasetURLsWhitelist";
import DatasetsSegments from "../app/Dashboard/Datasets/DatasetsSegments";

const tabConstants = {
    "Segments": DatasetsSegments,
    "Reports": DatasetReports,
    "URLs Whitelist": DatasetURLsWhitelist,
}

export {tabConstants}